<!-- 步骤条 -->
<template>
  <div class="step_box">
    <!-- 客户反馈 -->
    <div direction="vertical" :active="activeIndex">
      <!-- <div :title="$t('workOrder.client_feedback')"> -->
      <div class="desc_box description" @click.native="edit('1')">
        <p>{{ $t('workOrder.client_feedback') }}</p>
        <div class="width50">{{ $t('workOrder.client') }}：{{ raw.client ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.contact_details') }}：{{ raw.contactDetails ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.problem_desc') }}：
          {{ step1.descriptionZh ||'--' }}
          <span v-if="step1.descriptionKey==3">({{ step1.description ||'--' }})</span>
        </div>
        <div class="width50 time">{{ $t('workOrder.creation_time') }}：{{ raw.createTime | timeFormat }}</div>
      </div>
      <!-- </div> -->
      <!-- 售后分析 -->
      <!-- <div :title="$t('workOrder.after_sales')"> -->
      <div v-if="step2 != null" slot="description" class="desc_box" @click.native="edit('2')">
        <p>{{ $t('workOrder.after_sales') }}</p>
        <!-- <div class="width50">{{ $t('workOrder.return_date') }}：{{step2.returnTime, 'date' | timeFormat}}</div> -->
        <div class="width50">{{ $t('liBattery.productionDate') }}：{{step2.production_date, 'date' | timeFormat}}</div>
        <div class="width50">{{ $t('workOrder.ShipDate') }}：{{step2.ship_date, 'date' | timeFormat}}</div>
        <div class="width50">{{ $t('workOrder.warranty_expired') }}：{{ step2.isOut? $t('workOrder.yes'):$t('workOrder.no') }}</div>
        <div class="width50">{{ $t('workOrder.suggest') }}：
          {{ step2.descriptionZh ||'--' }}
          <span v-if="step2.descriptionKey==1">({{ step2.descriptionDetail ||'--' }})</span>
        </div>
        <div class="width50">{{ $t('workOrder.handler') }}：{{ step2.name }}</div>
        <div class="width50 time">{{ $t('workOrder.processing_time') }}：{{ step2.handleTime | timeFormat }}</div>
        <div class="width50">{{ $t('workOrder.state_flow') }}：{{ step2.statusZh ||'--' }}</div>
      </div>
      <!-- </div> -->
      <!-- 品质检查 -->
      <!-- <div :title="$t('workOrder.quality_inspection')"> -->
      <div v-if="step3 != null" slot="description" class="desc_box" @click.native="edit('3')">
        <p>{{ $t('workOrder.quality_inspection') }}</p>
        <div class="width50">{{ $t('workOrder.order_num') }}：{{ step3.singleNumber ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.whether_unpack') }}：{{ step3.isUnpack?$t('workOrder.yes'):$t('workOrder.no') }}</div>

        <div class="width50">{{ $t('workOrder.production_date') }}：{{step3.production_date, 'date' | timeFormat}}</div>
        <div class="width50">{{ $t('workOrder.ship_date') }}：{{step3.ship_date, 'date' | timeFormat}}</div>
        <div class="width50">{{ $t('workOrder.return_date') }}：{{step3.return_date, 'date' | timeFormat}}</div>
        <div class="width50">{{ $t('workOrder.VisualInspection') }}：{{ step3.exterior ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.FunctionalTest') }}：{{ step3.function ||'--' }}</div>

        <div class="width50">{{ $t('workOrder.remark') }}：{{ step3.description ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.handler') }}：{{ step3.name ||'--' }}</div>
        <div class="width50 time">{{ $t('workOrder.processing_time') }}：{{ step3.handleTime | timeFormat }}</div>
        <div class="width50">{{ $t('workOrder.state_flow') }}：{{ step3.statusZh ||'--' }}</div>
      </div>
      <!-- </div> -->
      <!-- 维修处理 -->
      <!-- <div :title="$t('workOrder.repair_processing')"> -->
      <div v-if="step4 != null" slot="description" class="desc_box" @click.native="edit('4')">
        <p>{{ $t('workOrder.repair_processing') }}</p>
        <div class="width50">{{ $t('workOrder.cause_analysis') }}：{{ step4.reason ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.maintenance_scope') }}：{{ step4.scope ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.precautions') }}：{{ step4.measure ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.question_category') }}：{{ problemTypeHandle(step4.problemType) ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.remark') }}：{{ step4.description ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.handler') }}：{{ step4.name ||'--' }}</div>
        <div class="width50 time">{{ $t('workOrder.processing_time') }}：{{ step4.handleTime | timeFormat }}</div>
        <div class="width50">{{ $t('workOrder.state_flow') }}：{{ step4.statusZh ||'--' }}</div>
      </div>
      <!-- </div> -->
      <!-- 生产线处理 -->
      <!-- <div :title="$t('workOrder.line_handling')"> -->
      <div v-if="step5 != null" slot="description" class="desc_box" @click.native="edit('5')">
        <p>{{ $t('workOrder.line_handling') }}</p>
        <div class="width50">{{ $t('workOrder.finished_testing') }}：{{ testStatus(step5.finishedTest) ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.aging_test') }}：{{ testStatus(step5.agingTest) ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.recheck') }}：{{ testStatus(step5.recheck) ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.packaging_storage') }}：{{ step5.isPack? $t('workOrder.yes'):$t('workOrder.no') }}</div>
        <div class="width50">{{ $t('workOrder.suggest') }}：{{ step5.description ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.handler') }}：{{ step5.name ||'--' }}</div>
        <div class="width50 time">{{ $t('workOrder.processing_time') }}：{{ step5.handleTime | timeFormat }}</div>
        <div class="width50">{{ $t('workOrder.state_flow') }}：{{ step5.statusZh ||'--' }}</div>
      </div>
      <!-- </div> -->
      <!-- /PMC处理 -->
      <!-- <div :title="$t('workOrder.pmc_handling')"> -->
      <div v-if="step6 != null" slot="description" class="desc_box" @click.native="edit('6')">
        <p>{{ $t('workOrder.pmc_handling') }}</p>
        <div class="width50">{{ $t('workOrder.inventory_date') }}：{{step6.warehousing , 'date' | timeFormat}}</div>
        <div class="width50">{{ $t('workOrder.ship_date') }}：{{step6.shipping , 'date' | timeFormat}}</div>
        <div class="width50">{{ $t('workOrder.remark') }}：{{ step6.description ||'--' }}</div>
        <div class="width50">{{ $t('workOrder.handler') }}：{{ step6.name }}</div>
        <div class="width50 time">{{ $t('workOrder.processing_time') }}：{{ step6.handleTime | timeFormat }}</div>
        <div class="width50">{{ $t('workOrder.state_flow') }}：{{ step6.statusZh ||'--' }}</div>
      </div>
      <!-- </div> -->
      <!-- 完成 -->
      <!-- <div :title="raw.status == 101? $t('workOrder.scrapped'):$t('workOrder.finish')" class="desc_box">
        <p>{{ raw.status == 101?$t('workOrder.scrapped'):$t('workOrder.finish') }}</p>
        <div v-if="raw.status >= 100" slot="description">
          <div v-if="raw.remark" :xs="12" :sm="12" :lg="12">{{ $t('workOrder.remark') }}：{{ raw.remark }}</div>
          <div class="width50 time">{{ $t('workOrder.processing_time') }}：{{ raw.updateTime | timeFormat }}</div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { problemTypes, statusOptions } from '../options'
export default {
  components: {},
  props: {
    raw: {}
  },
  data() {
    return {
      problemTypes,
      statusOptions
    }
  },
  computed: {
    step1() {
      if (this.raw.step1) {
        // return this.getStatusZh(this.raw.step2)
        var step = this.getStatusZh(this.raw.step1)
        var configList = this.$storage.get('configList') || []
        step.descriptionZh = '--'
        configList.forEach((v, i) => {
          if (v.key == 'faultDescription') {
            var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
            arr.forEach((m, i) => {
              if (step.descriptionKey == i)step.descriptionZh = m
            })
          }
        })
        return step
      }
      return null
    },
    step2() {
      if (this.raw.step2) {
        // return this.getStatusZh(this.raw.step2)
        var step = this.getStatusZh(this.raw.step2)
        var configList = this.$storage.get('configList') || []
        step.descriptionZh = '--'
        configList.forEach((v, i) => {
          if (v.key == 'faultDescription') {
            var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
            arr.forEach((m, i) => {
              if (step.descriptionKey == i)step.descriptionZh = m
            })
          }
        })
        return step
      }
      return null
    },
    step3() {
      if (this.raw.step3) {
        var step = this.getStatusZh(this.raw.step3)
        var configList = this.$storage.get('configList') || []
        step.exterior = '--' // descriptionZh
        step.function = ''
        configList.forEach((v, i) => {
          if (v.key == 'appearance') {
            var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
            arr.forEach((m, i) => {
              if (step.exteriorKey == i)step.exterior = m
            })
          }
          if (v.key == 'function') {
            var arr = (this.$store.state.language == 'zh' ? v.valueList : v.valueEnList) || []
            arr.forEach((m, i) => {
              if (step.functionKey.indexOf(i) > -1)step.function += m + ','
            })
          }
        })
        return step
      }
      return null
    },
    step4() {
      if (this.raw.step4) {
        return this.getStatusZh(this.raw.step4)
      }
      return null
    },
    step5() {
      if (this.raw.step5) {
        return this.getStatusZh(this.raw.step5)
      }
      return null
    },
    step6() {
      if (this.raw.step6) {
        return this.getStatusZh(this.raw.step6)
      }
      return null
    },
    activeIndex() {
      if (this.raw.status >= 100) return 7
      return this.raw.status - 1
    }
  },
  methods: {
    getStatusZh(stepStr) {
      var step = JSON.parse(stepStr)
      step.statusZh = '--'
      if (this.statusOptions && this.statusOptions instanceof Array) {
        this.statusOptions.forEach(v => {
          if (v.value == step.status) {
            step.statusZh = this.$t('workOrder.' + v.label)
          }
        })
      }
      for (var attr in step) {
        if (!step[attr] && step[attr] != 0)step[attr] = '--'
      }
      return step
    },
    descHandle(str) {
      if (str) {
        return JSON.parse(str).description
      }
      return '--'
    },
    edit(current) {
      this.$emit('edit', current)
    },
    problemTypeHandle(val) {
      let name = ''
      this.problemTypes.forEach(element => {
        if (element.value == val) name = element.label
      })
      if (name) {
        return this.$t('workOrder.' + name)
      }
      return '--'
    },
    testStatus(val) {
      if (val == 1) return this.$t('workOrder.not_performed')
      if (val == 2) return this.$t('workOrder.pass')
      if (val == 3) return this.$t('workOrder.fail')
      return '--'
    }
  }
}
</script>

<style lang='scss' scoped>
.step_box {
  padding: 20px;
}

.desc_box {
  cursor: pointer;
  p {
    font-size: 16px;
    margin: 4px 0;
    color: #333;
    margin-left: 10px;
    font-weight: bold;
  }
  .contact {
    font-size: 18px;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .time {
    font-size: 14px;
    // margin-bottom: 20px;
  }
}
.width50{
  width: calc(50% - 25px);
  display: inline-block;
  margin:10px;
}
.desc_box{
  border-bottom: 1px solid #e6ebf0;
}
</style>
